import React from 'react'
import PropTypes from 'prop-types'

import ImageSlider from 'components/shared/card/image-slider'
import LocationIcon from 'components/public/building-pages/heading/location-icon'
import { Link, useHistory } from 'react-router-dom'

const SuggestionBuildingCard = ({ ...props }) => {
  const history = useHistory()

  const {
    url,
    name = '',
    address,
    averagePrice,
    images,
    className,
  } = props

  const handleOnImageClick = (e) => {
    e.preventDefault()
    if (url) {
      history.push(url)
    }
  }

  return (
    <div className="mt-5 space-profile  flex flex-col h-full border border-secondary-graywhite rounded-lg transition-shadow duration-500 ease-in-out hover:shadow-card">
      <div className={`${className} relative pb-5/8 cursor-pointer max-h-max`}>
        <ImageSlider
          onClick={handleOnImageClick}
          className="absolute rounded w-full h-full"
          images={images}
        />
      </div>
      <div className="px-5 lg:mt-3 lg:mb-5 mb-0 md:mt-10 mt-12">
        <div className="my-1">
          <div className="flex justify-between">
            <p className="md:text-base font-bold text-sm">
              <span>{averagePrice}</span>
            </p>
          </div>
        </div>
        <div className="border-secondary-graywhite border-t pt-2">
          <Link target="_blank" to={url} className="font-bold text-sm">
            {name}
          </Link>
          <div className="flex md:mt-1 mt-0">
            <LocationIcon className="mr-1" />
            <span className="md:text-base text-sm" itemScope itemType={`http://schema.org/PostalAddress`}>
              {address}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

SuggestionBuildingCard.propTypes = {
  className: PropTypes.string,
  images: PropTypes.array,
  name: PropTypes.string,
  averagePrice: PropTypes.string,
  unit: PropTypes.string,
  url: PropTypes.string,
  address: PropTypes.string,
}

export default SuggestionBuildingCard
